import { useTranslation } from "react-i18next";

import styled from "styled-components";
import FlexWrapper from "../../../components/FlexWrapper";
import Img from "../../../components/Img";
import Title from "../../../components/Text/title";
import { media } from "../../../utils/theme";

export const Wrapper = styled.div`
  max-width: 335px;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  margin-bottom: 24px;
  height: auto;
  max-height: 292px;
  overflow: hidden;

  @media (max-width: 1680px) {
    max-width: 310px;
  }

  ${media.lessThan("tablet")} {
    width: 100%;
    max-width: 100%;
    margin-top: 1rem;
    max-height: 100%;
  }

  ${media.lessThan("small")} {
    max-width: 100%;
    margin-top: 1rem;
  }
`;

const Application = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <a href="https://onelink.to/inexpayweb" target="_blank">
        <Img
          src="/home/app/application.png"
          alt="download app"
          className="block"
        />
      </a>
    </Wrapper>
  );
};

export default Application;
